<template>
  <div class="app-container">
    <basic-container>
      <div class="operation">
        <div v-if="!isEdit">
          <el-button @click="cancel" size="medium">取消</el-button>
          <el-button size="medium" type="primary" @click="onSubmit(false)">保存为草稿</el-button>
          <el-button size="medium" type="primary" @click="onSubmit(true)">发布</el-button>
        </div>
        <div v-else>
          <el-button @click="cancel" size="medium">取消</el-button>
          <el-button size="medium" type="primary" @click="onEditSubmit()">保存</el-button>
        </div>
      </div>
      <el-form ref="examForm" class="sizeForm" :model="examForm" label-width="100px" size="medium" :rules="rules">
        <el-row>
          <el-col>
            <el-form-item label="考试标题" prop="title">
              <el-input v-model="examForm.title"  placeholder="请输入考试标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="考试描述">
              <el-input type="textarea" :rows="2" maxlength="255" v-model="examForm.description"  placeholder="请输入考试描述"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item label="考试分类">
              <el-select class="exam-list-filter-value" placeholder="类型" v-model="examForm.category" clearable size="small">
                <el-option
                  v-for="item in examCategoryOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col >
            <el-form-item label="考生范围" required>
              <div class="scope-radio" >
                <el-radio v-model="scope" label="some">部分人</el-radio>
              </div>
              <div v-if="scope === 'some'">
                <el-button @click="memberDialogVisible = true">选择人员</el-button>
                <span v-if="selsectMembers.members.length > 0 || selsectMembers.tags.length > 0" class="paper-span">已选择 {{ selsectMembers.members.length }} 人 &nbsp;&nbsp; {{ selsectMembers.tags.length}} 个标签</span>
              </div>
              <div class="scope-radio">
                <el-radio  v-model="scope" label="all">全部人</el-radio>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="试卷名称" required>
              <el-button @click="paperDialogVisible = true">选择试卷</el-button>
              <span v-if="examForm.paperTitle" class="paper-span">{{examForm.paperTitle}} ( {{examForm.totalScore}} 分)</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="开始时间" prop="startedTime">
              <el-date-picker
                v-model="examForm.startedTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                align="right"
                default-time="00:00:00"
                :picker-options="pickerOptionsStart">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="结束时间" prop="endedTime">
              <el-date-picker
                v-model="examForm.endedTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                align="right"
                default-time="23:59:59"
                :picker-options="pickerOptionsEnd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="考试时长" prop="duration">
              <el-input-number :min="0" :step="10" 
                v-model="examForm.duration"  
                controls-position="right"
                placeholder="请输入考试时长"></el-input-number>分钟
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="考试次数" prop="limitTimes">
              <el-input-number :min="1" :step="1" step-strictly
                v-model="examForm.limitTimes"  
                controls-position="right"
                placeholder="请输入考试次数"></el-input-number>次
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="及格分数" prop="passScore">
              <el-input-number :min="0" :step="1" :precision="1"
                v-model="examForm.passScore"  
                controls-position="right"
                placeholder="请输入及格分数"></el-input-number>分
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </basic-container>
    <el-dialog
      :visible.sync="paperDialogVisible"
      title="选择试卷"
      width="1200px"
      :destroy-on-close="true"
      @close="closeDialog">
      <el-row>
        <dialog-component ref="paperList" :tableOption="paperDialogOption" :paperPrototypeId="examForm.paperPrototypeId"/>
        <span>没有合适试卷，<em style="color: blue;" @click="goCreatePaper()">点击去创建</em></span>
      </el-row>
      <span slot="footer">
        <template>
          <el-button @click="closeDialog">取消</el-button>
          <el-button class="article-submit-btn" type="primary" @click="setPaper">确认</el-button>
        </template>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="memberDialogVisible"
      title="选择人员"
      width="1200px"
      :destroy-on-close="true"
      @close="closeDialog">
      <el-row>
        <member-dialog :selectList="selsectMembers" ref="memberList" />
      </el-row>
      <span slot="footer">
        <template>
          <el-button @click="closeMemberDialog">取消</el-button>
          <el-button class="article-submit-btn" type="primary" @click="setMember">确认</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { createExam, editExam, getExamDetail, getMemberList } from '@/api/app/exam'
import { examCategoryOption } from '@/const/crud/app/exam'
import { paperDialogOption } from '@/const/crud/app/paper'
import dialogComponent from './components/dialog-component'
import moment from 'moment'
import MemberDialog from './components/member-dialog.vue'

export default {
  components: {
    dialogComponent,
    MemberDialog,
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if(moment(this.examForm.endedTime).diff(moment(this.examForm.startedTime)) <= 0) {
        callback(new Error('开始时间必须小于结束时间！'));
      } if (moment(this.examForm.endedTime).diff(moment()) <= 0) {
        callback(new Error('结束时间必须大于当前时间！'));
      }
      else {
        callback();
      }
    };
    const validpaper = (rule, value, callback) => {
      if (!this.examForm.paperTitle) {
        callback(new Error('请选择试卷'));
      } else {
        callback();
      }
    };
    const validLimitTimes = (rule, value, callback) => {
      if (this.examForm.limitTimes < 1) {
        callback(new Error('考试次数至少一次'));
      } else {
        callback();
      }
    };
    
    const validPassScore = (rule, value, callback) => {
      if (this.examForm.passScore <= 0) {
        callback(new Error('及格分数必须大于0分'));
      } else if (this.examForm.passScore > this.examForm.totalScore ){
         callback(new Error('及格分数必须小于0分'));
      } else {
        callback();
      }
    };
    return {
      examCategoryOption,
      paperDialogOption,
      examForm: {
        title: '',
        description: '',
        category: '',
        paperTitle: '',
        paperPrototypeId: '',
        startedTime: '',
        endedTime: '',
        duration: '',
        limitTimes: 1,
        passScore: 0,
        attendeeScopes: [],
      },
      scope: 'all',
      loading: false,
      memberOption: [],
      paper: '',
      paperDialogVisible: false,
      memberDialogVisible: false,
      id: '',
      isEdit: false,
      selsectMembers: {
        members: [],
        tags: [],
      },
      rules: {
        title: [
          { type: 'string', required: true, message: '请输入考试标题', trigger: 'blur' },
          { max: 256, message: '不超过256个', trigger: 'blur' }
        ],
        startedTime: [
          { type: 'string', required: true, message: '请输入考试开始时间', trigger: 'change' },
          { validator: validateTime, trigger: 'change' }
        ],
        endedTime: [
          { type: 'string', required: true, message: '请输入考试结束时间', trigger: 'change' },
          { validator: validateTime, trigger: 'change' }
        ],
        duration: [
          { type: 'number', required: true, message: '请输入考试时长', trigger: ['blur', 'change'] },
        ],
        limitTimes: [
          { type: 'number', required: true, message: '请输入考试次数时间', trigger: ['blur', 'change'] },
          { required: true, validator: validLimitTimes, trigger: ['blur', 'change'] },
        ],
        passScore: [
          { type: 'number', required: true, message: '请输入及格分数', trigger: ['blur', 'change'] },
          { required: true, validator: validPassScore, trigger: ['blur', 'change'] },
        ],
      }
    };
  },
  created() {
  },
  mounted() {
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    }
  },
  methods: {
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    getParams() {
      const params = this.examForm
      params.duration = this.examForm.duration * 60
      params.attendeeScopes = []
      if(this.scope==='some') {
        this.selsectMembers.members.forEach(item => {
          params.attendeeScopes.push({
            relativeId: item.memberId,
            type: 1
          })
        })
        this.selsectMembers.tags.forEach(item => {
          params.attendeeScopes.push({
            relativeId: item.tagId,
            type: 2
          })
        })
      } else {
        params.attendeeScopes = []
      }
      return params;
    },
    onSubmit(isPublish) {
      const params = this.getParams()
      if (isPublish) {
        params.status = 2
      } else {
        params.status = 1
      }
      this.$refs.examForm.validate((valid) => {
        if (valid) {
          if (!params.paperPrototypeId) {
            this.$message({
              type: 'error',
              message: '请选择试卷后提交'
            })
          } else {
            createExam(params).then(res => {
              if (res.data.code === 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                })
                this.cancel();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
              }
            }).catch(err => {
              this.$message({
                message: err,
                type: 'error'
              })
            })
          }
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    },
    getDetail() {
      getExamDetail(this.id).then(res => {
        this.examForm = res.data.data;
        this.examForm.duration = Math.floor(this.examForm.duration / 60)
        this.examForm.paperTitle = res.data.data.paperPrototype.title;
        this.examForm.totalScore = res.data.data.paperPrototype.totalScore;

        if (JSON.stringify(this.examForm.attendeeScopeInfo) != '{}') {
          this.scope = 'some'
          if (this.examForm.attendeeScopeInfo.memberList) {
            this.examForm.attendeeScopeInfo.memberList.forEach(item => {
              this.selsectMembers.members.push({memberId: item.relativeId, nickname: item.nickname}) 
            })
          }
           if (this.examForm.attendeeScopeInfo.tagList) {
            this.examForm.attendeeScopeInfo.tagList.forEach(item => {
              this.selsectMembers.tags.push({tagId: item.relativeId, tagName: item.tagName}) 
            })
          }
        }
        
      }).catch(error => {
        this.$message({
          message: '获取考试详情失败',
          type: 'error'
        })
      })
    },
    onEditSubmit() {
      const params = this.getParams()
      this.$refs.examForm.validate((valid) => {
        if (valid) {
          editExam(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.cancel();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    },
    searchMethod(query) {
      if (query !== '') {
        this.loading = true;
        getMemberList({nickname: query}).then(res => {
          if (res.data) {
            this.memberOption = res.data.data
          }
          this.loading = false;
        }).catch(err => {

        })

      } else {
        this.memberOption = [];
      }
    },
    closeDialog() {
      this.paperDialogVisible = false;
    },
    closeMemberDialog() {
      this.memberDialogVisible = false;
    },
    setPaper() {
      const paperInfo = this.$refs.paperList.selectPaper
      this.examForm.paperTitle = paperInfo.title;
      this.examForm.totalScore = paperInfo.totalScore;
      this.examForm.paperPrototypeId = paperInfo.id;
      this.closeDialog()
    },
    setMember() {
      const memberInfo = this.$refs.memberList.selectMember
      const tagInfo = this.$refs.memberList.selectTag
      this.selsectMembers.members = memberInfo
      this.selsectMembers.tags = tagInfo
      this.closeMemberDialog()
    },
    goCreatePaper() {
       this.$router.push({
        path: '/app/exam/paper/add'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .operation {
    text-align: right;
  }
  .sizeForm{
    width: 650px;
    .paper-span {
      margin-left: 10px;
      color: blue;
    }
  }
  .scope-radio {
    margin: 10px 0 10px 0;
  }
</style>
